<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

onMounted(async () => {
  // Check if user is authenticated on app load
  const token = localStorage.getItem('access_token');
  if (token) {
    await authStore.fetchCurrentUser();
  }
});
</script>